export default __webpack_public_path__ + "static/media/container_docker.42acaea4.svg";